export const TraceTypes = {
    Error: 'error',
    Clicks: 'clicks',
    UserEvent: 'userEvent',
    Performance: 'performance',
    Information: 'information'
}